import { formatPrice } from "./format";

export default async function formatInputMoeda(campo: string, form: any): Promise<void> {
	let moedastr = form.current?.getFieldValue(`${campo}`);

	moedastr = moedastr.replace(/\D/g, '');

	if (moedastr) {
		moedastr = moedastr.replace(/([0-9]{2})$/g, ',$1');

		if (moedastr.length > 6) {
			moedastr = moedastr.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');
		};

		let valor = moedastr.replace('R$', '');
		valor = valor.replace(' ', '');
		valor = valor.replace('.', '');
		valor = valor.replace(',', '.');

		form.current?.setFieldValue(`${campo}`, `${formatPrice(Number(valor))}`);
	} else {
		moedastr = moedastr.replace(/\D/g, '');
		form.current?.setFieldValue(`${campo}`, `${formatPrice(moedastr)}`);
	};
}